import { Component, HostListener, OnInit } from '@angular/core';
import {
  DocumentTypesRepository,
  IDocumentType,
  DocumentTypeSortOptions,
} from '../../../../state/documenttype.repository';
import { DocumentTypesService } from '../../../../state/documenttype.service';
import { TrackRender } from 'app/shared/front-perfomance';
import { GeneralDataRepository } from 'app/helpers/repository/general-data.repository';

@TrackRender()
@Component({
  selector: 'app-documenttype-page',
  templateUrl: './documenttype-page.component.html',
  styleUrls: ['./documenttype-page.component.scss'],
})
export class DocumenttypePageComponent implements OnInit {
  sortOptions = DocumentTypeSortOptions;
  innerWidth = 0;
  searchFilter: string = '';

  deleteConfirmation: IDocumentType | null = null;
  constructor(
    public repo: DocumentTypesRepository,
    public service: DocumentTypesService,
    public genData: GeneralDataRepository
  ) {}

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.innerWidth = window.innerWidth;
  }
  ngOnInit(): void {
    this.refreshDataProject();
    this.innerWidth = window.innerWidth;
  }
  refreshDataProject() {
    this.service.reloadPageCustom(this.searchFilter).subscribe();
    /*  this.repo.all$;*/
  }
  handleDeleteClick(post: IDocumentType) {
    this.service.deleteCustom(post.id).subscribe((x) => {
      this.refreshDataProject();
    });
  }

  setFilter(filter?: string) {
    filter ? (this.searchFilter = filter) : (this.searchFilter = '');
    this.service.docSearchRelodePage(this.searchFilter).subscribe();
  }

  updateDocumentType(folder: IDocumentType) {
    const id = folder.id;
    const name = folder.name;
    const isShownOnSideMenu = !folder.isShownOnSideMenu;
    this.service
      .updateDocumenttype({
        id,
        name,
        isShownOnSideMenu,
      })
      .subscribe((x) => {
        console.log(x);
        if (x) {
          folder.isShownOnSideMenu = isShownOnSideMenu;
          this.genData.updateAllGeneralData(true);
        }
      });
  }
}
